import type { FC } from "react";
import type { IconCommonProps } from "@/icons/shared.ts";

export const IconRightLine: FC<IconCommonProps> = ({ width, height, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width ?? 24}
      height={height ?? 24}
      fill="none"
      stroke={color ?? "#000000"}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M17 12H3m8 6l6-6l-6-6m10-1v14" />
    </svg>
  );
};
